import ScannerTable from "../components/ScannerTable";
// import TradeModal from "../components/TradeModal";
import useScanner from "../hooks/useScanner";
// import { useTrade } from "../hooks/useTrade"; // This line was commented out in the original, keeping it that way.
import * as React from "react";
// import Tabs from "@mui/material/Tabs";
// import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { Button, Typography } from "@mui/material";
import { useContext, useEffect } from "react";
import { useLivePrices } from "../hooks/useLivePrices";
import TopPicks from "../components/TopPicks";
import { AuthContext } from "../contexts/AuthContext";
import StaleDataAlert from "../components/StaleDataAlert";

// interface TabPanelProps {
//   children?: React.ReactNode;
//   index: number;
//   value: number;
// }

// function CustomTabPanel(props: TabPanelProps) {
//   const { children, value, index, ...other } = props;

//   return (
//     <div
//       role="tabpanel"
//       hidden={value !== index}
//       id={`simple-tabpanel-${index}`}
//       aria-labelledby={`simple-tab-${index}`}
//       {...other}
//     >
//       {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
//     </div>
//   );
// }

// function a11yProps(index: number) {
//   return {
//     id: `simple-tab-${index}`,
//     "aria-controls": `simple-tabpanel-${index}`,
//   };
// }

import { useMarketStatus } from "../hooks/useMarketStatus";
import RefreshIcon from "@mui/icons-material/Refresh";

export default function SwingStocks() {
  const {
    swingStocksResults,
    scanSwingStocks,
    syncAllStocks,
    scanning,
    syncing,
  } = useScanner();

  const { marketStatus } = useMarketStatus();

  const authContext = useContext(AuthContext);
  const isAdmin = authContext?.isAdmin || false;

  const { prices, getLivePrice } = useLivePrices();

  useEffect(() => {
    // Combine all instrument_tokens for WebSocket subscription
    const tokens = [
      ...swingStocksResults.map((item) => Number(item.instrument_token)),
      // ...screenerScannerResults.map((item) => Number(item.instrument_token)),
    ].filter(Boolean);
    // console.log("combined tokens", tokens);

    if (tokens?.length > 0) getLivePrice(tokens);
  }, [swingStocksResults]);

  // const handleChange = (event: React.SyntheticEvent, newValue: number) => {
  //   setValue(newValue);
  // };

  // const [contentData, setContentData] = React.useState<any>();

  // const startTrade = (item) => {
  //   // setContentData(item);
  //   openTradeModal(item.symbol, item.lastPrice, item.instrumentToken);
  // };

  return (
    <Box sx={{ width: "100%", maxWidth: "100%", overflowX: "hidden" }}>
      <div>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            borderBottom: "1px solid #e0dcdc",
            mb: 3,
            gap: "10px",
            pb: 1
          }}
        >
          <Typography variant="h4" fontWeight="700" color="primary">
            Swing Stocks
          </Typography>

          <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center', width: '70%', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'left' }}><TopPicks />
      <StaleDataAlert 
        isStale={marketStatus?.dataHealth?.isStale} 
        lastDataDate={marketStatus?.dataHealth?.lastDataDate} 
      /></Box>
            {isAdmin && (
              <Box sx={{ display: 'flex', gap: 1, alignItems: 'right' }}>
                <Button
                  size="small"
                  onClick={() => syncAllStocks()}
                  disabled={syncing}
                  variant="outlined"
                  startIcon={<RefreshIcon />}
                >
                  {syncing ? "Syncing..." : "Sync Stocks"}
                </Button>
                <Button
                  size="small"
                  onClick={() => scanSwingStocks()}
                  disabled={scanning}
                  variant="contained"
                  startIcon={<RefreshIcon />}
                >
                  {scanning ? "Scanning..." : "Scan Now"}
                </Button>
              </Box>
            )}
          </Box>
        </Box>
        
        {swingStocksResults && (
          <ScannerTable
            isLoading={scanning}
            results={swingStocksResults}
            // onTrade={(data) => startTrade(data)}
            prices={prices as any}
            // latestPrices={latestPrices}
          />
        )}
      </div>

      {/* {tradeModalSymbol && (
        <OrderModal
          open={openModal}
          onClose={() => closeTradeModal()}
          stock={tradeModalSymbol}
          onSubmit={(data) => confirmTrade(data)}
          currentPrice={prices[instrumentToken]?.price}
          instrumentToken={instrumentToken}
        />
      )} */}
    </Box>
  );
}
